import styles from "./productDetailPrice.module.scss";
import { NumericFormat } from "react-number-format";
import PropTypes from "prop-types";
import LabelText from "../../atoms/label/LabelText";
import { numberFormat } from "../../../utils/helperServices";

const ProductDetailPrice = ({
                              label,
                              nowText,
                              wasText,
                              saveText,
                              amount,
                              prevAmount,
                              saveAmount,
                              currency,
                              saveSuffix,
                              className,
                              forText,
                              dealText,
                              amountStyle
                            }) => {

  return (
    <div className={`${styles.textWhite} ${className}`} id={`${label}-container`}>
      <div className={styles.whiteLabel}>{label}</div>
      <div className={`${styles.price}`} >
        <div className={`${saveAmount > 0 ? styles.specialPrice : ''} ${styles["price__main"]}`}>
					<span className={styles["price__amount"]}>
						<NumericFormat
              displayType="text"
              value={numberFormat(amount)}
              prefix={currency}
              thousandSeparator={true}
              className={amountStyle && styles[amountStyle]}
            />
            {dealText && (
              <span className={amountStyle && styles[amountStyle]}>{dealText}</span>
            )}
					</span>
        </div>

        {saveAmount > 0 && (
          <>
            <div className={styles["price__was"]}>
              <span className={styles["prefix"]}>{wasText}</span>
              <NumericFormat
                displayType="text"
                value={numberFormat(prevAmount)}
                prefix={currency}
                thousandSeparator={true}
              />
              {dealText && (
                <span>{dealText}</span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

ProductDetailPrice.defaultProps = {
  nowText: "Now only",
  wasText: "Was",
  saveText: "Save",
  currency: "R",
  saveSuffix: "!",
  label: "Price:",
  forText: "For only ",
};
ProductDetailPrice.propTypes = {
  nowText: PropTypes.string,
  wasText: PropTypes.string,
  saveText: PropTypes.string,
  currency: PropTypes.string,
  saveSuffix: PropTypes.string,
  amount: PropTypes.number,
  prevAmount: PropTypes.number,
  saveAmount: PropTypes.number,
  label: PropTypes.string,
  className: PropTypes.string,
  forText: PropTypes.string,
  dealText: PropTypes.string,
  amountStyle: PropTypes.string,
};

export default ProductDetailPrice;
